(() => {
  const start = () => {
    const root = document.querySelector('.fsm-collection-progressive');
    const fallback = root?.querySelector('[data-fsm-collection-fallback]');
    if (!root || !fallback || root.dataset.fsmPaginationMounted) return;
    root.dataset.fsmPaginationMounted = 'true';

    const links = new Map();
    const originalAttributes = new WeakMap();
    let frame = 0;

    const pageNumber = (button, current) => {
      const text = button.textContent.trim();
      const label = button.getAttribute('aria-label') || '';
      if (/^\d+$/.test(text)) return Number(text);
      const numbered = label.match(/(?:seite|page)\s+(\d+)/i);
      if (numbered) return Number(numbered[1]);
      if (/nächste|next/i.test(label)) return current + 1;
      if (/vorher|zurück|previous|prev/i.test(label)) return Math.max(1, current - 1);
      return null;
    };

    const pageUrl = (page) => {
      const url = new URL(location.href);
      url.hash = '';
      if (page > 1) url.searchParams.set('page', String(page));
      else url.searchParams.delete('page');
      return url.pathname + url.search;
    };

    const syncCanonical = () => {
      const query = new URLSearchParams(location.search);
      const canonical = root.ownerDocument.querySelector('link[rel="canonical"]');
      if (!canonical || !fallback.dataset.canonicalBase) return;
      const target = new URL(fallback.dataset.canonicalBase);
      const parameters = [...query.keys()];
      const filtered = parameters.some((key) => !/^(page|preview_theme_id|preview_script_id|_ab|_fd|_sc|utm_.+|gclid|fbclid)$/.test(key));
      const page = Number(query.get('page'));
      if (!filtered && Number.isInteger(page) && page > 1) target.searchParams.set('page', String(page));
      if (canonical.href !== target.href) canonical.href = target.href;
    };

    const sync = () => {
      frame = 0;
      const app = root.querySelector('.boost-sd__filter-block');
      const productLink = app?.querySelector('.boost-sd__product-item a[href*="/products/"]');
      const emptyCollection = Number(fallback.dataset.productCount) === 0 && app?.querySelector('.boost-sd__product-list');
      const emptyResults = app?.querySelector('.boost-sd__product-list-pagination-in-collection-search-empty-message')?.textContent.trim();
      if (!root.hasAttribute('data-fsm-boost-ready') && (productLink || emptyCollection || emptyResults)) {
        root.dataset.fsmBoostReady = 'true';
        fallback.hidden = true;
      }
      if (!root.hasAttribute('data-fsm-boost-ready')) return;

      for (const [button, link] of links) {
        if (!root.contains(button)) {
          link.remove();
          links.delete(button);
        }
      }

      const current = Number(new URLSearchParams(location.search).get('page')) || 1;
      for (const button of root.querySelectorAll('.boost-sd__pagination button')) {
        const page = pageNumber(button, current);
        if (!page || button.disabled || button.getAttribute('aria-disabled') === 'true') {
          links.get(button)?.remove();
          links.delete(button);
          delete button.dataset.fsmPaginationSource;
          const original = originalAttributes.get(button);
          if (original) {
            button.hidden = original.hidden;
            for (const name of ['aria-hidden', 'tabindex']) {
              if (original[name] === null) button.removeAttribute(name);
              else button.setAttribute(name, original[name]);
            }
          }
          continue;
        }
        let link = links.get(button);
        if (!link) {
          if (!originalAttributes.has(button)) {
            originalAttributes.set(button, {
              hidden: button.hidden,
              'aria-hidden': button.getAttribute('aria-hidden'),
              tabindex: button.getAttribute('tabindex')
            });
          }
          link = document.createElement('a');
          link.addEventListener('click', (event) => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (!root.contains(button) || button.disabled) return;
            event.preventDefault();
            button.click();
            schedule();
          });
          links.set(button, link);
        }
        const href = pageUrl(page);
        const classes = button.className + ' fsm-pagination-link';
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        if (link.className !== classes) link.className = classes;
        if (link.innerHTML !== button.innerHTML) link.innerHTML = button.innerHTML;
        for (const name of ['aria-label', 'aria-current', 'title']) {
          const value = button.getAttribute(name);
          if (value !== null && link.getAttribute(name) !== value) link.setAttribute(name, value);
          else if (value === null && link.hasAttribute(name)) link.removeAttribute(name);
        }
        if (link.parentNode !== button.parentNode) button.before(link);
        if (!button.hasAttribute('data-fsm-pagination-source')) button.dataset.fsmPaginationSource = 'true';
        button.hidden = true;
        button.setAttribute('aria-hidden', 'true');
        button.tabIndex = -1;
      }
      syncCanonical();
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(sync);
    };

    new MutationObserver(schedule).observe(root, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current', 'aria-disabled', 'disabled']
    });
    window.addEventListener('popstate', schedule);
    sync();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
